export default "__VITE_ASSET__DHnNRlrV__"